export default __webpack_public_path__ + "static/media/shield-done.93620215.svg";